export const loginFormTheme = {
  textField: {
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#ffffff83",
      },
    },
    "& .MuiFormHelperText-root.Mui-error": {
      color: "#fff",
    },
  },
  button: {
    textTransform: "none",
    borderRadius: 24,
    mt: 2,
    margin: 0,
    color: "#222",
    fontWeight: 600,
    fontSize: "16px !important",
    background: "linear-gradient(90deg, #00FFB0 0%, #00E0FF 100%)",
    "&.Mui-disabled": {
      background: "#bfc9d1",
      color: "#00000026",
    },
  },
} as const;
